export const appIdentifiers = {
    search(term, existing_ids, query_type, country_code) {
        existing_ids = existing_ids || [];
        query_type   = query_type || 'restricted_app';
        return $.getJSON(AdminRoutes.searchAdminAppIdentifiersPath({ term, query_type, existing_ids, country_code }));
    }
};
